import styled, { keyframes } from 'styled-components';
import { EGG_TIMINGS } from './self-like-easter-egg.constants';

const slideUp = keyframes`
  0% {
    transform: translate(-50%, 18%) scale(0.96);
    opacity: 0;
  }
  60% { opacity: 1; }
  85% {
    transform: translate(-50%, -7px) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -7px) scale(1);
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const slideDown = keyframes`
  0% {
    transform: translate(-50%, -8px) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, 18%) scale(0.96);
    opacity: 0;
  }
`;

export const EchoWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 6.5rem;
  height: 6.5rem; 
  pointer-events: none;
  z-index: 1;
  animation: ${slideUp} ${EGG_TIMINGS.slideUpMs}ms ease-out forwards,
    ${slideDown} ${EGG_TIMINGS.slideDownMs}ms ease-in forwards
      ${EGG_TIMINGS.slideUpMs + EGG_TIMINGS.crossfadeMs + EGG_TIMINGS.variantHoldMs + EGG_TIMINGS.crossfadeMs + EGG_TIMINGS.defaultHoldMs}ms;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const EchoImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  image-rendering: auto;
`;

export const DefaultEchoImg = styled(EchoImg)`
  position: absolute;
  inset: 0;
  opacity: 1;
  animation: ${fadeOut} ${EGG_TIMINGS.crossfadeMs}ms ease forwards ${EGG_TIMINGS.slideUpMs}ms,
    ${fadeIn} ${EGG_TIMINGS.crossfadeMs}ms ease forwards
      ${EGG_TIMINGS.slideUpMs + EGG_TIMINGS.crossfadeMs + EGG_TIMINGS.variantHoldMs}ms;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const VariantEchoImg = styled(EchoImg)`
  position: absolute;
  inset: 0;
  opacity: 0;
  animation: ${fadeIn} ${EGG_TIMINGS.crossfadeMs}ms ease forwards ${EGG_TIMINGS.slideUpMs}ms,
    ${fadeOut} ${EGG_TIMINGS.crossfadeMs}ms ease forwards
      ${EGG_TIMINGS.slideUpMs + EGG_TIMINGS.crossfadeMs + EGG_TIMINGS.variantHoldMs}ms;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const TooltipContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 66px;
  z-index: 3;
  pointer-events: none;

  /* Base transform */
  transform: translateY(calc(-50% - 6px));

  display: flex;
  padding: 1.2rem;
  align-items: flex-start;
  gap: 0.8rem;
  flex: 1 0 0;
  border-radius: 0.5rem;
  background: #121212;
  box-shadow: 0px 3px 13px 0px rgba(21, 28, 43, 0.07);
  min-width: 154px;
  max-width: 200px;
  white-space: nowrap;

  opacity: 0;
  animation: ${fadeIn} ${EGG_TIMINGS.crossfadeMs}ms ease forwards ${EGG_TIMINGS.slideUpMs}ms, ${fadeOut} ${EGG_TIMINGS.crossfadeMs}ms ease forwards ${EGG_TIMINGS.slideUpMs + EGG_TIMINGS.crossfadeMs + EGG_TIMINGS.variantHoldMs}ms;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -8px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid #121212;
  }
`;

export const TooltipMessage = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 1.4;
  color: #f9f9fb;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
`;
